import profilepic from "../assests/profilepic.jpg";
import styles from "./Home.module.css";
import Ravinder_Saini_Resume from "../assests/Ravinder_Saini_Resume.pdf";
import { FaLinkedin } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";

export const Homepage = () => {
  return (
    <div name="home" className={styles.home}>
      <div className={styles.homediv}>
        <h1>Hi</h1>
        {/* <img  src="https://icons.iconarchive.com/icons/google/noto-emoji-people-bodyparts/512/12050-waving-hand-icon.png" alt="" /> */}

        <h1> I'am Ravinder </h1>
        <h1>Fronted Developer</h1>

        <a className={styles.a} href={Ravinder_Saini_Resume} download>
          <div className={styles.div}>Download CV</div>
        </a>

        <a href="https://www.linkedin.com/in/ravinder-k-120b4b197">
          <FaLinkedin size={30} />
        </a>
        <a href="https://github.com/RavinderTakda">
          <BsGithub size={30} />
        </a>
      </div>

      <div className={styles.homeimage}>
        <img className={styles.image} src={profilepic} />
      </div>
    </div>
  );
};
